<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Sobre a Serra & Lar';
</script>

<PageHeader title={titlePage} type={1}>
	<span slot="content">
		<h2 class="color-secondary">Quem Somos</h2>
	</span>
</PageHeader>

<div class="container" style="min-height: 400px;">

	<span class="float-sm-left mr-40 mb-40" style="max-width: 400px; text-align: center;">
		<div>
			<picture class="image-gallery float-sm-left" style="display: flex;">
				<img class="img-fluid" src="assets/images/fachada2.jpg" alt="Sede da imobiliária">
			</picture>
		</div>
	</span>
	<p>No  dia  06  de  junho  de  2005  fundou–se  a  empresa  Serra  e  Lar  Imóveis,  iniciando  suas atividades na cidade de Canela, na Rua Augusto Pestana, 186, sala 06.</p>
	<p>Em 2012 mudou-se para o outro lado da mesma rua, número 171 (casa) proporcionando mais espaço para seus colaboradores e conforto aos seus clientes, incluindo estacionamento próprio.</p>
	<p>Em dezembro de 2023 mudamos para sede própria na Rua Gabriel de Moraes Velho, 67, Palace Hotel, a 600m da Catedral de Pedra.</p>
	<p>Desde  o  início  nosso  intuito  sempre  foi  primar  por  qualidade  no  atendimento  e  ética profissional, com muito carinho em tudo que fizemos.</p>
	<p>A Serra e Lar está pronta para atendê-los, venha nos visitar!</p>
	<br />
	<p class="hidden-sm hidden-xs"><br></p>
	<p><b style="color: #175639;"><i class="far fa-bullseye-arrow color-accent"></i> Nossa Missão:</b> “Qualidade em bem atender.”</p>
	<br>
	<p><b style="color: #175639;"><i class="fas fa-heart color-accent"></i> Nossos Valores:</b></p>
	<u style="text-decoration: none;">
		<li><p><b><i class="fal fa-check"></i> Empatia</b>  buscamos  sempre  nos  colocar  no  lugar  do  outro, ouvindo com intuito de compreender e ajudar.</p></li>
		<li><p><b><i class="fal fa-check"></i> Respeito</b> tendo noção dos direitos e obrigações de si e do outro, aceitando as diferenças pois nem sempre haverá concordância e ou entendimento sobre alguma situação ou algo.</p></li>
		<li><p><b><i class="fal fa-check"></i> Gentileza</b> é possuir simpatia para demonstrar cuidado e atenção de modo que contagiemos de forma positiva todas as pessoas.</p></li>
		<li><p><b><i class="fal fa-check"></i> Integridade</b> ter sempre em mente a ética para com a condução de nossas tarefas, sendo transparente e honestas.</p></li>
	</u>
	<br>
	<hr>

	<div style="display: inline-block; clear: both;">

		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Premio" href="/assets/images/premios/TopOfMind2024.png" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/TopOfMind2024.png" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Prêmio Top Of Mind Canela - As marcas que o consumidor canelense tem na cabeça - 2024
			</small>                
		</span>  
		
		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Premio" href="/assets/images/premios/TopOfMind2023.png" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/TopOfMind2023.png" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Prêmio Top Of Mind Canela - As marcas que o consumidor canelense tem na cabeça - 2023
			</small>                
		</span>  
		
		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Fachada Serra&Lar" href="/assets/images/premios/premioProfissionais2022.jpg" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/premioProfissionais2022.jpg" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Pelo terceiro ano consecutivo, em 2022 a diretora da Serra e Lar Imóveis, Cláudia de Rossi Braga, recebeu o troféu profissionais do ano como corretora de imóveis em locação, na foto junto com seu esposo Édison e filhas Bianca e Camila.
			</small>
		</span>		

		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Premio" href="/assets/images/premios/TopOfMind2022.png" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/TopOfMind2022.png" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Prêmio Top Of Mind Canela - As marcas que o consumidor canelense tem na cabeça - 2022
			</small>                
		</span>        
   
		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Fachada Serra&Lar" href="/assets/images/premios/premioProfissionais2021.jpg" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/premioProfissionais2021.jpg" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Foto da equipe e da família De Rossi Braga ao lado da sua diretora recebendo o prêmio como Corretora de Imóveis em Locação – 2021.
			</small>
		</span>        
   
		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Premio" href="/assets/images/premios/TopOfMind2021.png" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/TopOfMind2021.png" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Prêmio Top Of Mind Canela - As marcas que o consumidor canelense tem na cabeça - 2021
			</small>                
		</span>  

		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Fachada Serra&Lar" href="/assets/images/premios/premioTopOfMind2021.jpg" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/premioTopOfMind2021.jpg" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Família De Rossi Braga recebendo o prêmio TOP OF MIND como a imobiliária mais lembrada no seguimento de Locações de Imóveis no ano de 2021.
			</small>
		</span>        
   
		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Fachada Serra&Lar" href="/assets/images/premios/premioProfissionais2020.jpg" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/premioProfissionais2020.jpg" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Foto da família De Rossi Braga ao lado da sua diretora recebendo o prêmio como Corretora de Imóveis em Locação – 2020.
			</small>
		</span>

		<span class="float-sm-left mr-20" style="width: 340px; min-height: 540px; text-align: center;">
			<picture class="image-gallery pt-20">
				<a class="item" title="Fachada Serra&Lar" href="/assets/images/premios/premioDestaque2015.jpg" target="_blank">
					<img class="img-fluid" src="/assets/images/premios/premioDestaque2015.jpg" alt="Prêmio" width="320"/>
				</a>
			</picture>
			<small class="pt-10 pb-30" style="display: flex; color: #808080; width: 320px;">
				Em 2015 a Diretora Cláudia de Rossi Braga sendo agraciada com o Prêmio “Destaque Empreendedor” Serra e Lar Imóveis 10 anos.
			</small>                
		</span>

	</div>
	
	

	<div class="button mt-40 text-center">        
		<a href="/contato" use:link replace title="" class="btn btn-secondary">
			FALE CONOSCO <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>

	<br /><br />

</div>